import React from "react";

import {MuiIcon, MuiIconExternalProps} from "./MuiIcon";

export const RefreshIcon = (props: MuiIconExternalProps) => {
    return (
        <MuiIcon {...props}
        >{'\ue5d5'}</MuiIcon>
    );
}
